import { ElementType } from '../types/drawing';

export interface KeyboardShortcut {
  key: string;
  ctrl?: boolean;
  shift?: boolean;
  cmd?: boolean;
  action: string;
  description: string;
}

export const TOOL_SHORTCUTS: Record<string, ElementType> = {
  '1': 'pencil',
  '2': 'pencil',
  '3': 'line',
  '4': 'arrow',
  '5': 'rectangle',
  '6': 'circle',
  '7': 'text',
  '8': 'eraser',
};

export const LAYER_SHORTCUTS: KeyboardShortcut[] = [
  {
    key: 'ArrowDown',
    cmd: true,
    action: 'sendBackward',
    description: 'Send backward',
  },
  {
    key: 'ArrowDown',
    cmd: true,
    shift: true,
    action: 'sendToBack',
    description: 'Send to back',
  },
  {
    key: 'ArrowUp',
    cmd: true,
    action: 'bringForward',
    description: 'Bring forward',
  },
  {
    key: 'ArrowUp',
    cmd: true,
    shift: true,
    action: 'bringToFront',
    description: 'Bring to front',
  },
];

export const isKeyMatch = (
  event: KeyboardEvent,
  shortcut: KeyboardShortcut
): boolean => {
  const keyMatch = event.key === shortcut.key || event.code === `Key${shortcut.key}`;
  const ctrlMatch = shortcut.ctrl ? event.ctrlKey : !event.ctrlKey;
  const shiftMatch = shortcut.shift ? event.shiftKey : !event.shiftKey;
  const cmdMatch = shortcut.cmd ? event.metaKey : !event.metaKey;

  return keyMatch && ctrlMatch && shiftMatch && cmdMatch;
};

export const getToolFromKey = (key: string): ElementType | null => {
  return TOOL_SHORTCUTS[key] || null;
};

export const isToolShortcut = (key: string): boolean => {
  return key in TOOL_SHORTCUTS;
};

export const isLayerShortcut = (event: KeyboardEvent): boolean => {
  return LAYER_SHORTCUTS.some(shortcut => isKeyMatch(event, shortcut));
};

export const getLayerActionFromEvent = (event: KeyboardEvent): string | null => {
  const shortcut = LAYER_SHORTCUTS.find(s => isKeyMatch(event, s));
  return shortcut ? shortcut.action : null;
};
